<template>
  <div class="com-box_sign" :style="{height: isEdit ? null : cmpHeight[tmpType]}">
    <div class="front" :class="{'active-front': isEdit}">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-signup :comData="{...value,...basicInfoForm,boolShowNotice:otherForm.boolShowNotice}" :tmpType="tmpType"/>
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <basic-info ref="basicInfoRef" v-model="basicInfoData" :createdTime="createdTime" :isModifying="isEditActivity"/>
      <sign-up v-model="formData"/>
      <sign-up-conf v-model="otherData" />
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import previewSignup from '@/pages/activity-home/components/sign-up'
import signUp from '../../components/sign-up'
import basicInfo from '../../components/basic-info'
import signUpConf from '../../components/sign-up-conf'
import _ from 'loadsh'
export default {
  components: {
    previewSignup,
    signUp,
    basicInfo,
    signUpConf
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    basicInfoForm: Object,
    otherForm: Object,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number,
    createdTime: [String,Number]
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // this.initForm(newVal);
          this.formData = {...newVal}
        }
      },
      deep: true,
      immediate: true
    },
    basicInfoForm: {
      handler(newVal,oldVal) {
        if (newVal !== oldVal) {
          this.basicInfoData = {...newVal}
        }
      },
      deep: true,
      immediate: true
    },
    otherForm: {
      handler(newVal,oldVal) {
        if (newVal !== oldVal) {
          this.otherData = {...newVal}
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
    }),
    // 是否编辑
    isEditActivity() {
      return this.$route.query.from == 'manager' ? true : false
    }
  },
  data() {
    return {
      isEdit: false,
      formData: {
        customField: []
      },
      basicInfoData:{},
      preFormData: {},
      otherData: {},
      cmpHeight: ['660px', '470px', '430px','470px','497px']
    }
  },
  methods: {
    initForm(val) {
      if (val) {
        this.preFormData = {...val};
      }
    },
    edit() {
      this.basicInfoData = _.cloneDeep(this.basicInfoForm)
      this.formData = _.cloneDeep(this.value)
      this.otherData = _.cloneDeep(this.otherForm)
      this.isEdit = !this.isEdit
      this.$emit('handle', ['signUp', false])
    },
    cancel() {
      this.isEdit = false
      this.$emit('handle', ['signUp', true])
    },
    save() {
      let isPass = true
      // 基础信息
      const basicInfoRef = this.$refs.basicInfoRef;
      if (basicInfoRef && !basicInfoRef.checkValid()) {
        isPass = false
        return false;
      }
      this.formData.customFieldStr = JSON.stringify(this.formData.customField)
      if (this.formData.boolSmsSet && this.isTeacher) {
        if (this.formData.smsText == '') {
          this.$toast('请输入报名成功的短信内容')
          isPass = false
          return
        }
      }
      let fieldIsPass = this.formData.customField.every(fieldItem => fieldItem.fieldKey != '')
      if (!fieldIsPass) {
        this.$toast('请输入报名自定义字段')
        isPass = false
        return
      }
      this.$emit('update:basicInfoForm',this.basicInfoData)
      this.$emit('change', this.formData);
      this.$emit('update:otherForm', this.otherData)
      this.$emit('handle',['signUp', true])

      this.isEdit = false
      return isPass
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }

  }

}
</script>

<style lang="stylus" scoped>
.com-box_sign {
  position: relative;
  padding-top: 10px;
  box-sizing: border-box;
  perspective: 800px;
  overflow hidden;
  // background: blue;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    backface-visibility: hidden;
    z-index: 6;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    background:#fff;
    margin-top: -10px;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      // border: 1px solid #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>